<template>
  <el-dialog
    :title="l('修改密码')"
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="750px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
    append-to-body
  >
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
    >
      <el-form-item :label="l('当前密码')" prop="old_password">
        <el-input
          v-model="DialogFormData.old_password"
          :placeholder="l('请输入') + l('当前密码')"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item :label="l('新密码')" prop="new_password">
        <el-input
          v-model="DialogFormData.new_password"
          :placeholder="l('请输入')+l('新密码')"
          show-password
        ></el-input>
      </el-form-item>
      <el-form-item :label="l('再次输入新密码')" prop="checkNewPassword">
        <el-input
          v-model="DialogFormData.checkNewPassword"
          :placeholder="l('再次输入新密码')"
          show-password
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{l("取 消")}}</el-button>
      <el-button type="primary" @click="submitForm">{{l("确 定")}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "EditPassword",
  mixins: [dialogMixin],
  data() {
    var validateNewPassword = (rule, value, callback) => {
      // if (!/^[a-zA-Z](\w){5,19}$/.test(value)) {
      if (!/^(\w){6,12}$/.test(value)) {
        callback(new Error(this.l("请输入6-12位的英文/数字密码")));
      } else {
        callback();
      }
    };
    var validateCheckNewPassword = (rule, value, callback) => {
      if (value != this.DialogFormData.new_password) {
        callback(new Error(this.l("两次输入密码不一致!")));
      } else {
        callback();
      }
    };
    return {
      DialogFormData: {
        old_password: "",
        new_password: "",
        checkNewPassword: "",
      },
      dialogRules: {
        old_password: [
          { required: true, message: this.l("请输入") + this.l("当前密码"), trigger: "blur" },
        ],
        new_password: [
          { required: true, message: this.l("请输入") + this.l("新密码"), trigger: "change" },
          { validator: validateNewPassword, trigger: "change" },
        ],
        checkNewPassword: [
          { required: true, message: this.l("再次输入密码"), trigger: "change" },
          { validator: validateCheckNewPassword, trigger: "change" },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }

        this.axios
          .put(`/api/account/change_password/`, {
            old_password: this.DialogFormData.old_password,
            new_password: this.DialogFormData.new_password,
          })
          .then((data) => {
            this.$confirm(this.l("密码修改成功,请重新登录"), "", {
              type: "warning",
              showClose: false,
              showCancelButton: false,
              closeOnClickModal: false,
            }).then(() => {
              this.$store.commit("logout");
            });
          });
      });
    },
  },
};
</script>


<style scoped lang="scss">
</style>

